<template>
  <div class="zjxForget">
    <div class="zxj_forget">
      <div class="zjx_forget__form">
        <div class="zxj_register__title">
          <p>忘记密码</p>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="手机号" prop="phone">
            <el-input class="inner_forget_width" v-model="ruleForm.phone">
            </el-input>
          </el-form-item>
          <el-form-item label="手机验证码" prop="phoneCode">
            <div class="inner_forget_width" style="display: flex">
              <el-input v-model="ruleForm.phoneCode"></el-input>
              <el-button
                class="specil_button"
                @click="findPassword"
                :disabled="isDisabled"
                >{{ sendMsg }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              class="inner_forget_width"
              v-model="ruleForm.password"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="surePassword">
            <el-input
              type="password"
              class="inner_forget_width"
              v-model="ruleForm.surePassword"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button class="register_btn" @click="submitForm('ruleForm')"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { vaildate } from "../../utils/validate.js";
import { findPassword } from "../../api/moudles/user.js";
import { forgetPassword } from "../../api/moudles/home.js";
export default {
  data() {
    const isPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!vaildate.isPassword(value)) {
        callback(new Error("密码长度不足6位"));
      } else if (!vaildate.CheckPassWord(value)) {
        callback(new Error("密码不符合规则"));
      } else if (this.ruleForm.surePassword) {
        if (value != this.ruleForm.surePassword) {
          callback(new Error("密码两次输入不一致"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isCheckPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!vaildate.isPassword(value)) {
        callback(new Error("密码长度不足6位"));
      } else if (!vaildate.CheckPassWord(value)) {
        callback(new Error("密码不符合规则"));
      } else if (value != this.ruleForm.password) {
        callback(new Error("密码两次输入不一致"));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!vaildate.isPhone(value)) {
        //判断用户输入的值是否符合规则
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
      }
    };
    return {
      disable: false,
      isDisabled: false,
      newNum: 60,
      sendMsg: "发送验证码",
      ruleForm: {
        password: "",
        surePassword: "",
        phone: "",
        phoneCode: "",
      },
      rules: {
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            validator: isPassword,
            trigger: "blur",
          },
        ],
        surePassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur",
          },
          {
            validator: isCheckPassword,
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "change",
          },
          {
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        phoneCode: [
          {
            required: true,
            message: "请输入手机验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //忘记密码
    async forgetPassword() {
      await forgetPassword({
        data: {
          password: this.ruleForm.password,
          phone: this.ruleForm.phone,
          phoneCode: this.ruleForm.phoneCode,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            setTimeout(() => {
              if (window.screen.width < 760) {
                this.$router.replace("/phoneIndex/login");
              } else {
                this.$router.replace("/login");
              }
            }, 1500);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        },
      });
    },
    // 发送注册短信
    async findPassword() {
      console.log(this.disable);
      if (this.disable) {
        this.$message.error(
          "短信验证码5分钟内只能发送一条，30分钟内有效，如果长时间未收到，请查看是否被短信拦截"
        );
        return;
      }
      if (!vaildate.isPhone(this.ruleForm.phone)) {
        this.$message.error("请检查手机号输入是否正确");
        return;
      }
      await findPassword({
        data: {
          mobile: this.ruleForm.phone,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.disable = true;
            setTimeout(() => {
              this.disable = false;
            }, 300000);

            this.sendMsg = "60s";
            this.isDisabled = true;
            let newInerl = setInterval(() => {
              this.sendMsg = this.newNum-- + "s";
            }, 1000);
            setTimeout(() => {
              this.newNum = 60;
              clearInterval(newInerl);
              this.sendMsg = "重新发送";
              this.isDisabled = false;
            }, 59000);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.forgetPassword();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .zxj_forget {
    width: 100%;
    height: 600px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inner_forget_width {
    width: 100%;
  }

  .zjx_forget__form {
    width: 95%;
    padding-top: 50px;
  }
  .register_btn {
    width: 300px;
    background-color: #c22c25;
    color: #fff;
    margin-left: -50px;
  }
  .zjxForget {
    min-height: 620px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media screen and (min-width: 750px) {
  .zxj_forget {
    width: 1200px;
    height: 650px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inner_forget_width {
    width: 300px;
  }

  .zjx_forget__form {
    width: 36%;
    padding-top: 50px;
  }
  .register_btn {
    width: 300px;
    background-color: #c22c25;
    color: #fff;
  }
  .zjxForget {
    min-height: 710px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.specil_button {
  position: absolute;
  right: 33px;
  border: none;
  margin-top: 1px;
}
.zxj_register__title {
  height: 70px;
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
  text-align: center;
  line-height: 70px;
  font-size: 22px;
}
</style>
